import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { Alert, Button } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import MeasurementAddingRenderingCompanent from '../../Measurement/MeasurementAddingRenderingComponent';

const MeasurementFilledForm = ({ control, watch, handleAudit = () => {} }) => {
  const { fields: measurementFields } = useFieldArray({
    control,
    name: 'measurements',
  });

  return (
    <div>
      <div className="font-semibold w-full text-lg">การวัดค่า</div>
      <hr className="my-2" />
      {_.isEmpty(measurementFields) ? (
        <div className="p-4">
          ไม่มีตัวแปรใดให้กรอก
          <Alert severity="info" className="my-2 lg:w-1/2">
            เกิดความผิดพลาดขึ้นหรือไม่ ถ้าคุณมั่นใจว่าขั้นตอนนี้มีตัวแปรให้กรอก
            แต่ไม่มีตัวแปรออกมา
            <div>
              กรณากดปุ่ม รีเฟรชข้อมูล ข้างล่างนี้
              เพื่อที่ระบบจะลองดึงข้อมูลใหม่อีกครั้ง
            </div>
            <Button
              variant="outlined"
              size="small"
              className="my-2"
              onClick={handleAudit}
            >
              รีเฟรชข้อมูล
            </Button>
          </Alert>
        </div>
      ) : (
        <div className="flex flex-wrap overflow-x-auto ">
          {_.map(measurementFields, (_field, index) => (
            <div key={_field.id} className="my-2 w-full lg:w-1/3 lg:px-2 pt-2">
              <div className="font-semibold">
                {_field?.measurement_type?.name}{' '}
              </div>
              <div className="my-2 text-gray-600 text-sm">
                {_field?.measurement_type?.description || ''}
              </div>
              <div className="my-1">
                <MeasurementAddingRenderingCompanent
                  control={control}
                  measurementControllerName={`measurements[${index}]`}
                  measurementType={_field?.measurement_type}
                  watch={watch}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

MeasurementFilledForm.propTypes = {
  control: PropTypes.func,
  watch: PropTypes.func,
  handleAudit: PropTypes.func,
};

export default MeasurementFilledForm;
